import React from 'react'
import Video1 from '../assets/videos/Comprehensive Plan - Edit 1.mp4'

export default function Home() {
  return (
    <div>

      <main role="main" className="flex-shrink-0 modular min-vh-100 my-5">
        <div className="container container-first mt-5 text-start">

          <div className="row pt-5">
            <h1>Welcome to the Imagine Burleson: 2020 Midpoint Update web portal!</h1>
          </div>
          <div className="row">
            <p>The City of Burleson is in the process of updating its 2030 Imagine Burleson Comprehensive Plan, which was adopted by the City in 2010. Please browse this site to review key points of the draft plan and learn how to get involved.</p>
          </div>
          <div className="row">
            <h2>Get started by watching this quick video!</h2>
          </div>
          <div className="row">
            <div className="embed-responsive">
              <video controls="controls" className="embed-responsive-item" src={Video1} type="video/mp4" style={{maxWidth:"100%"}}>
                Your browser does not support the video tag.
              </video>
            </div>
          </div>


        </div>

      </main>

    </div>
  )
}
